// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupProps } from "@insite/mobius/CheckboxGroup";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateDraftParameter";
import { useTrailerTrackingV2State } from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import { TrailerTrackingV2BillingTypeApiValues } from "@store/Framework/Types/ApiModels";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC } from "react";

const billingTypeEntries = Object.entries(TrailerTrackingV2BillingTypeApiValues);
const billingTypeSeparator = ",";

export interface TrailerTrackingV2FilterFieldBillingTypeProps {}

export interface TrailerTrackingV2FilterFieldBillingTypeStyles {
    checkbox?: CheckboxPresentationProps;
    checkboxGroup?: CheckboxGroupProps;
    fieldWrapper?: InjectableCss;
}

export const trailerTrackingV2FilterFieldBillingTypeStyles: TrailerTrackingV2FilterFieldBillingTypeStyles = {
    fieldWrapper: filterDrawerProps.fieldWrapper,
    checkboxGroup: filterDrawerProps.checkboxGroupWithoutLabel,
    checkbox: filterDrawerProps.checkbox,
};

const styles = trailerTrackingV2FilterFieldBillingTypeStyles;

const TrailerTrackingV2FilterFieldBillingType: FC<TrailerTrackingV2FilterFieldBillingTypeProps> = () => {
    const dispatch = useAppDispatch();
    const { billingType } = useTrailerTrackingV2State().draftParameter;
    const billingTypesArray = billingType?.split(billingTypeSeparator) || [];

    return (
        <FilterDrawerSection title={translate("Billing Type")} isAccordion={true}>
            <StyledWrapper {...styles.fieldWrapper}>
                <CheckboxGroup {...styles.checkboxGroup} label={translate("Billing Type")}>
                    {billingTypeEntries.map(([key, billingType]) => {
                        return (
                            <Checkbox
                                {...styles.checkbox}
                                key={key}
                                checked={billingTypesArray.includes(billingType)}
                                onChange={(_, isChecked) => {
                                    dispatch(
                                        updateDraftParameter({
                                            billingType: billingTypeEntries
                                                .reduce<string[]>((result, [_, currentBillingType]) => {
                                                    if (billingType === currentBillingType) {
                                                        return isChecked ? [...result, currentBillingType] : result;
                                                    }

                                                    if (billingTypesArray.includes(currentBillingType)) {
                                                        return [...result, currentBillingType];
                                                    }

                                                    return result;
                                                }, [])
                                                .join(billingTypeSeparator),
                                        }),
                                    );
                                }}
                            >
                                {translate(`TrailerTrackingBillingType_${key}`)}
                            </Checkbox>
                        );
                    })}
                </CheckboxGroup>
            </StyledWrapper>
        </FilterDrawerSection>
    );
};

export default TrailerTrackingV2FilterFieldBillingType;
